import Masterlistofmachine from '../../pages/masterlistofMachine/List';
import {
  Clause10,
  ManMachineMatrix,
  ManMachineMatrixList,
  AnnualPreventivePlanNewTiles,
  AnnualPreventivePlanNewPlanList,
  AnnualPreventivePlanNewPlanCreate,
  AnnualPreventivePlanNewStatus,
  AnnualPreventivePlanNewStatusCheckListCreate,
  AnnualPreventivePlanMasterNewChecklist,
  AnnualPreventivePlanMasterNewChecklistCreate,
  PredictiveMaintenancePlanTiles,
  PredictiveMaintenancePlanList,
  PredictiveMaintenancePlanCreate,
  PredictiveMaintenancePlanStatus,
  PredictiveMaintenancePlanStatusCheckListCreate,
  PredictiveMaintenancePlanMasterChecklist,
  PredictiveMaintenancePlanMasterChecklistCreate,
  MttrAndMtbfDashboardTabs,
  CreateMttrAndMtbfReport,
  CreateDownTimeAnalysisReport,
  BreakDownSlipList,
  CreateBreakDownSlip,
  MasterListOfLocation,
  MasterListOfBreakdown,
} from '../../pages/clause10Page';
import CreateMachineHistory from '../../pages/masterlistofMachine/machineHistory/CreateMachineHistory';

const annualPreventivePlan = [
  //  annual preventive plan new
  {
    path: 'annualPreventivePlanNewTiles',
    element: <AnnualPreventivePlanNewTiles />,
  },
  {
    path: 'annualPreventivePlanNewPlanList',
    element: <AnnualPreventivePlanNewPlanList />,
  },
  {
    path: 'annualPreventivePlanNewCreate/:id',
    element: <AnnualPreventivePlanNewPlanCreate />,
  },

  {
    path: 'annualPreventivePlanNewStatus',
    element: <AnnualPreventivePlanNewStatus />,
  },
  {
    path: 'annualPreventivePlanNewStatusCheckListCreate/:id?',
    element: <AnnualPreventivePlanNewStatusCheckListCreate />,
  },
  {
    path: 'annualPreventivePlanMasterNewChecklist',
    element: <AnnualPreventivePlanMasterNewChecklist />,
  },
  {
    path: 'annualPreventivePlanNewMasterChecklistCreate/:id?',
    element: <AnnualPreventivePlanMasterNewChecklistCreate />,
  },

  // annual preventive new  end
];

const predictiveMaintenancePlan = [
  //  predictive maintenance plan
  {
    path: 'predictiveMaintenancePlanTiles',
    element: <PredictiveMaintenancePlanTiles />,
  },
  {
    path: 'predictiveMaintenancePlanList',
    element: <PredictiveMaintenancePlanList />,
  },
  {
    path: 'predictiveMaintenancePlanCreate/:id',
    element: <PredictiveMaintenancePlanCreate />,
  },
  {
    path: 'predictiveMaintenancePlanStatus',
    element: <PredictiveMaintenancePlanStatus />,
  },
  {
    path: 'predictiveMaintenancePlanStatusCheckListCreate/:id?',
    element: <PredictiveMaintenancePlanStatusCheckListCreate />,
  },
  {
    path: 'predictiveMaintenancePlanMasterChecklist',
    element: <PredictiveMaintenancePlanMasterChecklist />,
  },
  {
    path: 'predictiveMaintenancePlanMasterChecklistCreate/:id?',
    element: <PredictiveMaintenancePlanMasterChecklistCreate />,
  },

  // predictive maintenance  end
];
// main route of clause 10
export const clause10 = [
  {
    path: 'clause10',
    element: <Clause10 />,
  },
  //Man Machine Matrix
  {
    path: 'manMachineMatrixList',
    element: <ManMachineMatrixList />,
  },
  {
    path: 'manMachineMatrix/:subDepartmentId',
    element: <ManMachineMatrix />,
  },
  {
    path: 'masterlistofmachine',
    element: <Masterlistofmachine />,
  },
  {
    path: 'machineHistory/:id',
    element: <CreateMachineHistory />,
  },
  {
    path: 'createMttrAndMtbfReport',
    element: <CreateMttrAndMtbfReport />,
  },
  {
    path: 'createDownTimeAnalysisReport',
    element: <CreateDownTimeAnalysisReport />,
  },
  {
    path: 'mttrAndMtbfReport/dashboard',
    element: <MttrAndMtbfDashboardTabs />,
  },
  // break down slip
  {
    path: 'breakDownSlipList',
    element: <BreakDownSlipList />,
  },
  {
    path: 'createEditBreakDownSlip/:id?',
    element: <CreateBreakDownSlip />,
  },
  {
    path: 'masterListOfLocationList',
    element: <MasterListOfLocation />,
  },
  {
    path: 'masterListOfBreakdownList',
    element: <MasterListOfBreakdown />,
  },
  ...predictiveMaintenancePlan,
  ...annualPreventivePlan,
];
